export default __webpack_public_path__ + "static/media/aluminum-cobra-3-phase.aed10587.png";